import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';

import axios from 'axios';
import { toError, assertOk } from '@/services/normalize';

import {
  BASE_URL,
  GET_TRANSFER_KEY,
  UPDATE_TRANSFER_KEY,
  GET_SEAMLESS_KEY,
  UPDATE_SEAMLESS_KEY,
  M_POST
} from '@/utils/api';

@Module({ name: 'apikey' })
export default class ApiKey extends VuexModule {
  listTransferKey: Array<Record<string, unknown>> = [];

  listSeamlessKey: Array<Record<string, unknown>> = [];

  @Mutation
  mutateTransferKey(list: Array<Record<string, unknown>>) {
    this.listTransferKey = list;
  }

  @Mutation
  mutateSeamlessKey(list: Array<Record<string, unknown>>) {
    this.listSeamlessKey = list;
  }

  @Action({ commit: 'mutateTransferKey', rawError: true })
  async FetchTransferKey(params: Record<string, unknown> = {}) {
    try {
      const { data } = await axios({
        url: BASE_URL + GET_TRANSFER_KEY,
        data: params,
        method: M_POST
      });

      assertOk(data, 'Fetch transfer key failed');
      const list = Array.isArray(data?.data) ? data.data : [];
      return list as Array<Record<string, unknown>>;
    } catch (err) {
      throw toError(err, 'Fetch transfer key failed');
    }
  }

  @Action({ rawError: true })
  async UpdateTransferKey(params: Record<string, unknown>) {
    try {
      const { data } = await axios({
        url: BASE_URL + UPDATE_TRANSFER_KEY,
        data: params,
        method: M_POST
      });

      assertOk(data, 'Update transfer key failed');
      return data?.status;
    } catch (err) {
      throw toError(err, 'Update transfer key failed');
    }
  }

  @Action({ commit: 'mutateSeamlessKey', rawError: true })
  async FetchSeamlessKey(params: Record<string, unknown> = {}) {
    try {
      const { data } = await axios({
        url: BASE_URL + GET_SEAMLESS_KEY,
        data: params,
        method: M_POST
      });

      assertOk(data, 'Fetch seamless key failed');
      const list = Array.isArray(data?.data) ? data.data : [];
      return list as Array<Record<string, unknown>>;
    } catch (err) {
      throw toError(err, 'Fetch seamless key failed');
    }
  }

  @Action({ rawError: true })
  async UpdateSeamlessKey(params: Record<string, unknown>) {
    try {
      const { data } = await axios({
        url: BASE_URL + UPDATE_SEAMLESS_KEY,
        data: params,
        method: M_POST
      });

      assertOk(data, 'Update seamless key failed');
      return data?.status;
    } catch (err) {
      throw toError(err, 'Update seamless key failed');
    }
  }
}
